/*
 *
 *  Mixin - Global Methods
 */

// deps
import { mapGetters } from 'vuex'

// export
export default {
  // computed
  computed: {
    // mapGetters
    ...mapGetters(['hasWebpSupport']),
    // is home
    isHome() {
      return this.$route.name === 'Home'
    },
    // is 404
    is404() {
      return this.$route.name === '404'
    }
  },
  // methods
  methods: {
    // is route
    isRoute(routeName) {
      return this.$route.name === routeName
    },
    // get image url
    getImageUrl(file, size) {
      // set inital path
      var path = `images%2F${file}`
      // add size
      if (size) path = `${path}@${size}`
      // add format
      const format = this.hasWebpSupport ? 'webp' : 'jpeg'
      if (size) path = `${path}.${format}`
      // add alt
      path = `${path}?alt=media`
      // set url
      var url = `${this.gVars.storageUrl}/${path}`
      //console.log('getStorageUrl url:', url)
      return url
    }
  }
}
